module.exports = __webpack_public_path__ + "img/single-man.dec55b37.svg";